import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';

/**
 * Process outside clicks
 * @param {HTMLElement} select select event fire
 * @param {HTMLElement} closestCustomSelect main wrapper custom select
 * @returns void
 */
function onClickOutsideSelect(closestCustomSelect) {
  document.addEventListener('click', function onClickOutsideEvent(e) {
    if (
      !closestCustomSelect.contains(e.target) &&
      closestCustomSelect.dataset.active === 'true'
    ) {
      dataToggle(closestCustomSelect, false);
      document.removeEventListener('click', onClickOutsideEvent);
    }
  });
}

/**
 * Load click event into custom selects
 */
function onClickCustomSelect(node) {
  const selects = $Qll('.custom-select__fire-event', node);
  selects.forEach((item) => {
    // prevent event bubbling when we have anchor elements inside of
    // the div
    if ($Q('a[href]', item)) {
      $Q('a[href]', item).addEventListener('click', (e) => e.stopPropagation());
    }

    item.addEventListener('click', () => {
      const closestCustomSelect = item.closest('.custom-select');

      dataToggle(closestCustomSelect, false);
      onClickOutsideSelect(closestCustomSelect);
    });
  });
}

function setValueCustomSelect(item) {
  const closestCustomSelect = item.closest('.custom-select');
  const labelSelected = closestCustomSelect.querySelector(
    '.custom-select__selected',
  );
  labelSelected.innerHTML = item.textContent;
  closestCustomSelect.dataset.active = 'false';
}

/**
 * Load click event into custom selects options
 */
function onClickSelectItem(node) {
  const selectItems = $Qll('.custom-select__option', node);

  selectItems.forEach((item) => {
    item.addEventListener('click', () => {
      setValueCustomSelect(item);
    });
  });
}

/**
 * Init events
 */
export function setupCustomSelect(node) {
  onClickCustomSelect(node);
  onClickSelectItem(node);
}
